/*
 * Gaia Naturelle × UMEK 5.0 — campaign behavior (vanilla JS, no dependencies).
 * Defines <gaia-umek-copy> only. Touches no Shopify/Wonder globals, events or components.
 * Lifecycle: connectedCallback binds, disconnectedCallback releases and restores neutral
 * state (Shopify theme-editor section load/unload). Pending clipboard results that
 * arrive after disconnect, or after a newer attempt, are ignored.
 * Registration is guarded, so a repeated <script> execution is harmless.
 */
(function () {
  "use strict";
  if (typeof window === "undefined" || !window.customElements) return;
  if (window.customElements.get("gaia-umek-copy")) return;

  var DEFAULT_OK = "Koda kopirana";
  var DEFAULT_FAIL = "Kopiranje ni uspelo. Koda je označena — kopiraj jo ročno (Ctrl/Cmd + C).";
  var RESET_MS = 4000;

  class GaiaUmekCopy extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
      this._timer = null;
      this._btn = null;
      this._attempt = 0;
    }

    connectedCallback() {
      if (this._btn) return; // already bound
      var btn = this.querySelector("[data-gaia-umek-copy-trigger]");
      if (!btn) return;
      this._btn = btn;
      this._status = this.querySelector("[data-gaia-umek-copy-status]");
      this._codeEl = this.querySelector("[data-gaia-umek-code-text]");
      // Stable configured label: never captured from a transient state.
      if (!btn.hasAttribute("data-gaia-umek-label")) btn.setAttribute("data-gaia-umek-label", btn.textContent.trim());
      this._label = btn.getAttribute("data-gaia-umek-label");
      this._reset();
      btn.addEventListener("click", this._onClick);
    }

    disconnectedCallback() {
      this._attempt++; // invalidate pending clipboard callbacks
      clearTimeout(this._timer);
      this._timer = null;
      if (this._btn) {
        this._btn.removeEventListener("click", this._onClick);
        this._reset();
      }
      this._btn = null;
    }

    _msg(name, fallback) {
      return this.getAttribute("data-gaia-umek-msg-" + name) || fallback;
    }

    _code() {
      return (this.getAttribute("data-gaia-umek-code") || (this._codeEl && this._codeEl.textContent) || "").trim();
    }

    _onClick() {
      var self = this;
      var id = ++this._attempt;
      var code = this._code();
      var clip = navigator.clipboard;
      if (!code || !clip || !window.isSecureContext) return this._fail();
      var p;
      try { p = clip.writeText(code); } catch (e) { return this._fail(); }
      Promise.resolve(p).then(
        function () { if (id === self._attempt && self._btn) self._ok(); },
        function () { if (id === self._attempt && self._btn) self._fail(); }
      );
    }

    _ok() {
      var msg = this._msg("ok", DEFAULT_OK);
      this.setAttribute("data-state", "copied");
      this._btn.textContent = msg;
      if (this._status) this._status.textContent = msg;
      this._scheduleReset();
    }

    _fail() {
      if (!this._btn) return;
      this.setAttribute("data-state", "error");
      this._btn.textContent = this._label; // never leave a stale success label
      if (this._status) this._status.textContent = this._msg("fail", DEFAULT_FAIL);
      if (this._codeEl) {
        var range = document.createRange();
        range.selectNodeContents(this._codeEl);
        var sel = window.getSelection();
        if (sel) { sel.removeAllRanges(); sel.addRange(range); }
      }
      this._scheduleReset();
    }

    _reset() {
      this.removeAttribute("data-state");
      if (this._btn) this._btn.textContent = this._label;
      if (this._status) this._status.textContent = "";
    }

    _scheduleReset() {
      var self = this;
      clearTimeout(this._timer);
      this._timer = setTimeout(function () { self._timer = null; if (self._btn) self._reset(); }, RESET_MS);
    }
  }

  window.customElements.define("gaia-umek-copy", GaiaUmekCopy);
})();
